import vuex from '@/store'
import dayjs from 'dayjs'
import api from '@/api'

import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(timezone)
import advancedFormat from 'dayjs/plugin/advancedFormat.js'
dayjs.extend(advancedFormat)

function getStationConfigByName(name) {
  if (!name) {
    name = vuex.getters.currentStation.station
  }
  return vuex.getters.stationConfigs.find((s) => s.station == name)
}

function getSystemByName(name, stationName) {
  let stationConfig = getStationConfigByName(stationName)
  return stationConfig?.stagehand.systems?.find((s) => s.name.toLowerCase() == name?.toLowerCase())
}

function getPlatformByName(name, stationName) {
  let currentStation = vuex.getters.currentStation

  // if we are looking for a different station, we need to get the platform from that station
  if (stationName && stationName != currentStation.station) {
    return getPlatformByNameAsync(name, stationName)
  }

  let platformOption = vuex.getters.platforms.find((i) => i.value == name)
  // convert to expected format
  return { name: platformOption?.value, system: platformOption?.settings?.system, ...platformOption }
}

async function getPlatformByNameAsync(name, stationName) {
  const cat = await api.newsdesk.getColumnOptions('platforms', false, stationName)
  let platformOptions = cat.data ?? []

  let platformOption = platformOptions.find((i) => i.value == name)
  // convert to expected format
  return { name: platformOption?.value, system: platformOption?.settings?.system, ...platformOption }
}

function getShowByName(showName) {
  let platform = getPlatformByName(showName)
  let systemName = platform?.system?.toLowerCase()
  if (!systemName) return
  let systemConfig = getSystemByName(systemName)
  let show = systemConfig?.shows.find((s) => s.name == showName)
  return show
}

function getAssignmentShowStartTime(assignment) {
  const show = getShowByName(assignment.platform)
  if (show?.startTime == null || !assignment?.story?.story_date) return
  let startTime = dayjs.tz(assignment.story.story_date, vuex.getters.currentTimezone).startOf('day').add(show.startTime, 'minutes')
  return startTime
}

function getAssignmentShowEndTime(assignment) {
  let startTime = getAssignmentShowStartTime(assignment)
  const show = getShowByName(assignment.platform)
  if (!startTime && show?.endTime == null) return
  return startTime.add(show.length, 'minutes')
}

function getAssignmentAutoPushStartTime(assignment) {
  if (!assignment?.platform) return
  const show = getShowByName(assignment.platform)
  const showStart = getAssignmentShowStartTime(assignment)
  if (show?.preStartTime == null || showStart == null) return
  let autoWindowOpens = showStart.subtract(show.preStartTime, 'minutes')
  return autoWindowOpens
}

function isStagehandRunning(stationName) {
  console.debug('isStagehandRunning', stationName)
  let stationContainers = vuex.getters.stationContainers ?? []
  if (!stationName) {
    stationName = vuex.getters.currentStation.station_name
  }
  let container = stationContainers.find((data) => data.station_name == stationName)
  return container?.health?.status === 'running'
}

function formatRemoteId(id) {
  // handle inews id format to 'simple remote id' format
  // if id is 8393478394.839439840.34 format, return 8393478394
  if (id?.split('.').length == 3) {
    return id.split('.')[0]
  }
  return id
}

export const stagehandUtils = {
  formatRemoteId,
  isStagehandRunning,
  getShowByName,
  getPlatformByName,
  getSystemByName,
  getAssignmentAutoPushStartTime,
  getAssignmentShowEndTime
}
